module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/en_shikoku-cb93c9f9753b0bcb23ccc7657cc977ff.jpg";